function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.097 25.7961C18.6639 26.5489 19 27.4855 19 28.5005C19 30.9858 16.9853 33.0005 14.5 33.0005C12.0147 33.0005 10 30.9858 10 28.5005C10 26.0152 12.0147 24.0005 14.5 24.0005C15.2467 24.0005 15.9509 24.1823 16.5708 24.5042L27.7528 11.3755L28.4011 10.6143L29.8921 11.9476L29.2437 12.7088L18.097 25.7961ZM12 28.5005C12 29.8812 13.1193 31.0005 14.5 31.0005C15.8807 31.0005 17 29.8812 17 28.5005C17 27.1198 15.8807 26.0005 14.5 26.0005C13.1193 26.0005 12 27.1198 12 28.5005Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7936 25.7951C24.2267 26.5479 23.8906 27.4845 23.8906 28.4995C23.8906 30.9848 25.9053 32.9995 28.3906 32.9995C30.8759 32.9995 32.8906 30.9848 32.8906 28.4995C32.8906 26.0142 30.8759 23.9995 28.3906 23.9995C27.6439 23.9995 26.9397 24.1814 26.3198 24.5032L15.1378 11.3745L14.4895 10.6133L12.9986 11.9466L13.6469 12.7079L24.7936 25.7951ZM30.8906 28.4995C30.8906 29.8802 29.7713 30.9995 28.3906 30.9995C27.0099 30.9995 25.8906 29.8802 25.8906 28.4995C25.8906 27.1188 27.0099 25.9995 28.3906 25.9995C29.7713 25.9995 30.8906 27.1188 30.8906 28.4995Z",
  fill: "currentColor"
});

var SvgCut = function SvgCut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cut.2273372f.svg";
export { ForwardRef as ReactComponent };